// @ts-nocheck
var collectors = {
  staging: 'com-tourlane-prod1.mini.snplow.net',
  production: 'com-tourlane-main.collector.snplow.net'
};
var snowplowScriptUrl = 'https://d1v1f48xjw0b9w.cloudfront.net/3.24.1/sp.min.js'; // @ts-ignore

var loadSnowPlowScript = function loadSnowPlowScript(p, l, o, w, i, n, g, callback) {
  if (!p[i]) {
    p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
    p.GlobalSnowplowNamespace.push(i);

    p[i] = function () {
      // eslint-disable-next-line prefer-rest-params
      (p[i].q = p[i].q || []).push(arguments);
    };

    p[i].q = p[i].q || [];
    n = l.createElement(o);
    g = l.getElementsByTagName(o)[0];
    n.async = 1;
    n.src = w;
    g.parentNode.insertBefore(n, g);
    callback();
  }
};
/**
 * Tasks completed by this event:
 * - load and insert the snowplow script
 * - initialise a newTracker
 */


export var SnowplowScript = function SnowplowScript(_ref) {
  var environment = _ref.environment,
      appId = _ref.appId,
      callback = _ref.callback,
      withWebVitals = _ref.withWebVitals;

  // There's no need to initalize tracker onLoad.
  // After the effect is executed window.snowplow is ready to collect the events into the queue (p[i].q).
  // Once snowplow script is downloaded and executed it invokes the queue of previously fired events.
  var init = function init() {
    window.snowplow('newTracker', 'sp', collectors[environment], {
      appId: appId,
      discoverRootDomain: true,
      post: true,
      forceSecureTracker: true,
      contexts: {
        webPage: true,
        performanceTiming: true,
        gaCookies: true
      }
    });

    if (withWebVitals) {
      window.snowplow('addPlugin', 'https://d1v1f48xjw0b9w.cloudfront.net/3.24.1/index.umd.min.js', ['snowplowWebVitals', 'WebVitalsPlugin']);
    }

    if (callback) {
      callback();
    }
  };

  loadSnowPlowScript(window, document, 'script', snowplowScriptUrl, 'snowplow', null, null, init);
  return null;
};
export default SnowplowScript;